import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { queryTypes, servicesHavaAraciParametreleriTypes } from 'src/types';
import { urlHelper } from 'src/app/helpers';
import { axiosc } from 'src/app/utils';

export const havaAraciParametreleriLookup = ({
  limit,
  load,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesHavaAraciParametreleriTypes.HavaAraciParametreleriLookupDataType): AxiosPromise<servicesHavaAraciParametreleriTypes.HavaAraciParametreleriLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  if (load) {
    query.load = load.join(',');
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.havaAraciParametreleri), {
    blockSpinner,
  });
};
